import { render, staticRenderFns } from "./ClientFiles.vue?vue&type=template&id=4abd556e"
import script from "./ClientFiles.vue?vue&type=script&lang=js"
export * from "./ClientFiles.vue?vue&type=script&lang=js"
import style0 from "./ClientFiles.vue?vue&type=style&index=0&id=4abd556e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports